import { createV3Queries } from "@query/utils/createV3Queries";
import { biometricIdentityVerificationsApi } from "@api";

/**
 * Biometric identity-verification registry — mirrors
 * `BiometricIdentityVerificationsApi` 1:1
 * (`/v3/compliance/biometric-identity-verifications`). Payee-only: a payer
 * reaches the verification through the request's embed instead (see
 * `queriesBiometricIdentityVerificationRequests`), so the requirement screens
 * use this registry only to start a session.
 *
 * `startBiometricIdentityVerification` needs no extra dependencies: starting a
 * session leaves the request untouched (the requirement reads are refreshed
 * from the completion callback), which is what v1's start mutation did.
 */
export const queriesBiometricIdentityVerifications = createV3Queries(
  "biometricIdentityVerificationsApi",
  biometricIdentityVerificationsApi
);
